import { ReactElement } from 'react';

export enum OnboardState {
  USER_INVITES = 'USER_INVITES',
  ONBOARDED = 'ONBOARDED',
}

export type TStepView = ReactElement;
